module.exports = __webpack_public_path__ + "static/img/img03.6638f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/116/img03.png
// module id = JnCw
// module chunks = 0